import type { QueryClient } from '@tanstack/react-query';

/** Base path for every dashboard companion endpoint. */
export const COMPANION_PATH = '/dashboard/companion';

/**
 * Query-key factory for the companion feed. Keyed on brand because the feed is
 * a brand's briefing, not a person's: switching brand must read a different
 * cache entry rather than show the previous brand's cards for a beat.
 *
 * Everything that stales the feed — a mutation, a realtime wake-up, a brand
 * switch — invalidates through {@link invalidateCompanionQueries} so the set of
 * keys can never drift between the callers.
 */
export const companionKeys = {
  all: ['companion'] as const,
  brand: (brandId: string) => ['companion', brandId] as const,
};

/**
 * Refetch one brand's feed. Falls back to the whole namespace when no brand is
 * known, which happens on a wake-up that arrives while the brand query is still
 * settling: refetching too much is cheap, refetching nothing is a stale panel.
 */
export const invalidateCompanionQueries = (
  queryClient: QueryClient,
  brandId?: string | null
): void => {
  queryClient.invalidateQueries({
    queryKey: brandId ? companionKeys.brand(brandId) : companionKeys.all,
  });
};
